$(document).ready(function () {

    
    $(".widgetPicker").each(function () {
        $(".widgetPicker .card-img-top").matchHeight();
    });

});